<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div class="flex-1">
      <div
        class="nav gap-x-3"
        title="HuiWuDetailRenYuanList"
        data-title="大交通管理"
      >
        <li
          v-if="state.selectIds?.length > 0"
          class="text-sm text-gray-400 flex items-center"
        >
          已选
          <strong class="text-orange-600 mx-1">{{
            state.selectIds?.length
          }}</strong>
          条数据
          <el-button type="danger" link @click="onClearSelect">
            清空
          </el-button>
        </li>
        <el-input
          v-model="state.params.keywords"
          class="c-search-white"
          clearable
          placeholder="关键字"
          @keyup.enter="onLoad()"
          @clear="onLoad()"
        >
          <template #suffix>
            <el-icon
              @click="onLoad()"
              color="#a2a2a2"
              title="搜索"
              class="font-bold cursor-pointer hover:opacity-60"
              ><Search
            /></el-icon>
          </template>
        </el-input>
        <div class="flex items-center">
          <el-button type="primary" icon="Download" @click="onImport()">
            导入嘉宾
          </el-button>
          <el-button type="primary" icon="Plus" @click="state.showAdd = true">
            添加人员
          </el-button>
          <el-button
            type="danger"
            icon="Delete"
            @click="onDeletes"
            :disabled="!state.selectIds?.length > 0"
            :title="!state.selectIds?.length > 0 ? '请先选择要操作的数据' : ''"
          >
            批量删除
          </el-button>
          <el-button type="primary" link @click="onExport" icon="Download">
            导出
          </el-button>
        </div>
      </div>
      <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
        <el-checkbox-group
          v-model="state.select_ids"
          class="flex flex-col overflow-hidden"
        >
          <el-table
            :data="state.table_list"
            v-loading="!Array.isArray(state.table_list)"
            element-loading-background="rgba(0, 0, 0, 0.2)"
            :default-sort="{
              prop: state.params.sort_field,
              order:
                state.params.sort_value == 'desc' ? 'descending' : 'ascending',
            }"
            row-key="meeting_transport_ticket_id"
            ref="tableDom"
            @sort-change="onSortChange"
            @row-click="onRowClick"
            :span-method="arraySpanMethod"
          >
            <el-table-column width="55">
              <template #header>
                <el-checkbox :value="-1" @change="onSelectAllChange" />
              </template>
              <template #default="{ row }">
                <el-checkbox
                  :value="row.id"
                  @click.stop=""
                  @change="onSelectChange"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="人员"
              prop="name"
              align="center"
              :width="100"
            >
              <template #default="{ row }">
                <c_tabgroup
                  :key="row.name"
                  :value1="row.name"
                  :value2="row.phone"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="行程类型"
              prop="xclx"
              align="center"
              :width="100"
            >
              <template #default="{ row }">
                <c_status
                  arrName="Meeting_Transport_Trip_Type"
                  :value="row.trip_type"
                  :key="row.trip_type"
                  showBg
                  class="m-auto"
                />
              </template>
            </el-table-column>
            <el-table-column label="状态" prop="zt" align="center" :width="100">
              <template #default="{ row }">
                <c_status
                  arrName="Meeting_Transport_Ticket_Status"
                  :value="row.status"
                  :key="row.status"
                  showBg
                  class="m-auto"
                />
              </template>
            </el-table-column>
            <el-table-column label="交通方式" align="center" :width="100">
              <template #default="{ row }">
                <c_status
                  v-if="row.ticket_type"
                  arrName="Meeting_Transport_Ticket_Type"
                  :value="row.ticket_type"
                  :key="row.ticket_type"
                  class="m-auto"
                />
                <text v-else>-</text>
              </template>
            </el-table-column>
            <el-table-column label="航班/车次" align="center" :width="100">
              <template #default="{ row }">
                <text>{{ row.transport_no || "-" }}</text>
              </template>
            </el-table-column>
            <el-table-column label="舱位" prop="cw" align="center" :width="100">
              <template #default="{ row }">
                <text v-if="row.ticket_type != 0">
                  {{
                    row.ticket_type == 1
                      ? row.d_train_seat_type_name
                      : row.d_airline_seat_type_name
                  }}
                </text>
                <text v-else>-</text>
              </template>
            </el-table-column>
            <el-table-column label="日期" align="center" :width="100">
              <template #default="{ row }">
                <text>{{ row.travel_date || "-" }}</text>
              </template>
            </el-table-column>
            <el-table-column label="出发时间" align="center" :width="100">
              <template #default="{ row }">
                <text>{{
                  row.departure_time
                    ? $dayjs(row.departure_time).format("YYYY-MM-DD HH:mm")
                    : "-"
                }}</text>
              </template>
            </el-table-column>
            <el-table-column label="出发地点" :width="100">
              <template #default="{ row }">
                <text>{{ row.departure_name || "-" }}</text>
              </template>
            </el-table-column>
            <el-table-column label="到达时间" align="center" :width="100">
              <template #default="{ row }">
                <text>{{
                  row.arrival_time
                    ? $dayjs(row.arrival_time).format("YYYY-MM-DD HH:mm")
                    : "-"
                }}</text>
              </template>
            </el-table-column>
            <el-table-column label="到达地点" align="center" :width="100">
              <template #default="{ row }">
                <text>{{ row.arrival_name || "-" }}</text>
              </template>
            </el-table-column>
            <el-table-column label="票价" align="right" :width="100">
              <template #default="{ row }">
                <text>
                  {{
                    !row.ticket_price || row.ticket_price == "0.00"
                      ? "-"
                      : row.ticket_price
                  }}
                </text>
              </template>
            </el-table-column>
            <el-table-column label="手续费" align="right" :width="100">
              <template #default="{ row }">
                <text>{{
                  !row.service_fee || row.service_fee == "0.00"
                    ? "-"
                    : row.service_fee
                }}</text>
              </template>
            </el-table-column>
            <el-table-column label="改签费" align="right" :width="100">
              <template #default="{ row }">
                <text>{{
                  !row.change_fee || row.change_fee == "0.00"
                    ? "-"
                    : row.change_fee
                }}</text>
              </template>
            </el-table-column>
            <el-table-column label="退票费" align="right" :width="100">
              <template #default="{ row }">
                <text>{{
                  !row.refund_fee || row.refund_fee == "0.00"
                    ? "-"
                    : row.refund_fee
                }}</text>
              </template>
            </el-table-column>
            <el-table-column label="退票损失费" align="right" :width="120">
              <template #default="{ row }">
                <text>{{
                  !row.refund_loss_fee || row.refund_loss_fee == "0.00"
                    ? "-"
                    : row.refund_loss_fee
                }}</text>
              </template>
            </el-table-column>
            <el-table-column label="金额合计" align="right" :width="100">
              <template #default="{ row }">
                <text>{{
                  !row.amount || row.amount == "0.00" ? "-" : row.amount
                }}</text>
              </template>
            </el-table-column>
            <el-table-column label="接送车辆" align="center" :width="100">
              <template #default="{ row }">
                <text>{{ row.meetingCar?.number || "-" }}</text>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              prop="handle"
              align="center"
              :width="80"
            >
              <template #default="{ row }">
                <div
                  class="flex flex-col justify-center items-center table-btn-clear-margin"
                >
                  <el-button
                    type="warning"
                    :icon="Edit"
                    link
                    @click.stop="
                      state.selectId = row.id;
                      state.showEdit = true;
                    "
                    >编辑
                  </el-button>
                  <el-button
                    type="danger"
                    :icon="Delete"
                    link
                    @click.stop="onDelete(row)"
                  >
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-checkbox-group>
        <c_page
          :total="state.totalCount"
          :pageIndex="state.params.page"
          :pageSize="state.params.limit"
          @onLoad="
            (page) => {
              state.params.page = page.pageIndex;
              state.params.limit = page.pageSize;
              onLoad();
            }
          "
        />
      </div>
    </div>
    <el-dialog
      v-model="state.showAdd"
      title="添加人员"
      class="c-el-dialog"
      style="height: 80%"
      :before-close="
        () => {
          state.showAdd = false;
        }
      "
    >
      <c_add
        :meeting_id="props.meeting_id"
        @close="
          state.showAdd = false;
          onLoad();
        "
      />
    </el-dialog>
    <el-dialog
      v-model="state.showEdit"
      title="编辑人员行程"
      class="c-el-dialog"
      style="max-height: 95%"
      append-to="#home_box"
      :before-close="
        () => {
          state.showEdit = false;
        }
      "
    >
      <c_edit
        :id="state.selectId"
        @close="
          state.showEdit = false;
          onLoad();
        "
      />
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_service_transport_attendee_page,
  meeting_service_transport_attendee_import,
  meeting_service_transport_attendee_del,
  meeting_service_transport_attendee_export,
} from "@/http/meetingservice";
import { funcExport, post_response } from "@/utils/funcs";
import { ElMessageBox, ElMessage } from "element-plus";

import c_add from "./Add.vue";
import c_edit from "./Edit.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: { c_add, c_edit },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      selectIds: [],
      select_ids: [],
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      // state.params.attend_type = 1; //仅加载嘉宾
      onLoad();
    });

    const onLoad = () => {
      delete state.table_list;

      meeting_service_transport_attendee_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.table_list = list;
          state.totalCount = count;
        }
      });
    };

    // 存储合并信息
    let spanArr = [];
    let pos = 0;
    const calculateSpan = (data, prop) => {
      spanArr = [];
      pos = 0;

      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          spanArr.push(1);
          pos = 0;
        } else {
          // 和上一行内容相同
          if (data[i][prop] === data[i - 1][prop]) {
            spanArr[pos] += 1;
            spanArr.push(0);
          } else {
            spanArr.push(1);
            pos = i;
          }
        }
      }
    };

    //列合并函数
    const arraySpanMethod = ({ row, column, rowIndex, columnIndex }) => {
      if (columnIndex == 0) {
        calculateSpan(state.table_list, "id");
        const _row = spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return { rowspan: _row, colspan: _col };
      }

      if (column.property === "name") {
        calculateSpan(state.table_list, "id");
        const _row = spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return { rowspan: _row, colspan: _col };
      }

      if (column.property === "handle") {
        calculateSpan(state.table_list, "id");
        const _row = spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return { rowspan: _row, colspan: _col };
      }
    };

    //导入嘉宾
    const onImport = () => {
      ElMessageBox.confirm(`您确定导入嘉宾吗？`, "导入嘉宾", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "is-plain",
      }).then(() => {
        meeting_service_transport_attendee_import({
          meeting_id: props.meeting_id,
        }).then((res) => {
          post_response(res, () => {
            onLoad();
          });
        });
      });
    };

    //删除
    const onDeletes = () => {
      ElMessageBox.confirm(
        `您确定<strong style='color:var(--el-color-danger)'>删除</strong>已选<strong style='color:#080'>${state.selectIds?.length}</strong>人员的行程数据吗？`,
        "删除确认",
        {
          confirmButtonText: "立即删除",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "error",
          customClass: "c-delete-dialog",
          confirmButtonClass: "el-button--danger",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_service_transport_attendee_del({
          id: state.selectIds?.join(","),
        }).then((res) => {
          if (res.status == 200) {
            ElMessageBox.alert(res.data?.msg, "提示", {
              dangerouslyUseHTMLString: true,
              type: "success",
              callback: () => {
                onLoad();
              },
            });
          } else {
            ElMessage({
              message: res.data,
              type: "error",
            });
          }
        });
      });
    };

    //删除
    const onDelete = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style='color:var(--el-color-danger)'>删除</strong>参会人<strong style='color:#080'>${row.name}</strong>的全部行程数据吗？`,
        "删除确认",
        {
          confirmButtonText: "立即删除",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "error",
          customClass: "c-delete-dialog",
          confirmButtonClass: "el-button--danger",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_service_transport_attendee_del({
          id: row.id,
        }).then((res) => {
          if (res.status == 200) {
            ElMessageBox.alert(res.data?.msg, "提示", {
              dangerouslyUseHTMLString: true,
              type: "success",
              callback: () => {
                onLoad();
              },
            });
          } else {
            ElMessage({
              message: res.data,
              type: "error",
            });
          }
        });
      });
    };

    //全选
    const onSelectAllChange = (val) => {
      if (val) {
        const ids = new Set(state.table_list.map((m) => m.id));
        state.select_ids = [-1, ...ids];
        state.selectIds = [...ids];
      } else {
        state.select_ids = [];
        state.selectIds = [];
      }
    };

    const onSelectChange = () => {
      setTimeout(() => {
        state.selectIds = state.select_ids?.filter((w) => w != -1);
      }, 200);
    };

    //行点击事件
    const onRowClick = (item) => {
      const index = state.select_ids?.indexOf(item.id);
      if (index > -1) {
        state.select_ids.splice(index, 1);
      } else {
        state.select_ids.push(item.id);
      }

      if (state.select_ids.filter((w) => w != -1)?.length <= 0)
        state.select_ids = [];

      state.selectIds = state.select_ids.filter((w) => w != -1);
    };

    //清空已选
    const onClearSelect = () => {
      state.select_ids = [];
      state.selectIds = [];
    };

    //导出
    const onExport = () => {
      let data = {
        ...state.params,
      };
      data.page = 1;
      data.limit = 0;

      funcExport(meeting_service_transport_attendee_export, data);
    };

    return {
      state,
      props,
      tableDom,
      onLoad,
      onDelete,
      onClearSelect,
      onRowClick,
      onDeletes,
      arraySpanMethod,
      onImport,
      onSelectAllChange,
      onExport,
      onSelectChange,
    };
  },
};
</script>

<style lang="scss" scoped></style>
